<div class="version-menu">
  <button
    type="button"
    class="version-menu__trigger"
    aria-haspopup="true"
    aria-controls="briefing-version-menu-panel"
    [attr.aria-expanded]="open()"
    (click)="toggle()">
    <i class="pi pi-history version-menu__icon" aria-hidden="true"></i>
    <span class="version-menu__title">Versão {{ viewed().versionNumber }}</span>
    @if (viewedTag(); as tag) {
      <!-- Na versão que gera, o selo é a fase atual e a dica traz quem pediu e quando. -->
      <span
        class="version-tag version-tag--{{ tag.tone }}"
        aria-live="polite"
        [pTooltip]="phaseHint() ?? ''"
        tooltipPosition="bottom"
        >{{ tag.label }}</span
      >
    }
    <i
      class="pi pi-chevron-down version-menu__chevron"
      [class.version-menu__chevron--open]="open()"
      aria-hidden="true"></i>
  </button>

  @if (open()) {
    <div
      id="briefing-version-menu-panel"
      class="version-menu__panel"
      role="region"
      aria-label="Versões do briefing">
      <div class="version-menu__head">
        <p class="version-menu__heading">Versões do briefing</p>
        <span class="version-menu__count">{{ model().countLabel }}</span>
      </div>

      <ul class="version-menu__list">
        @for (row of model().generated; track row.id) {
          <li
            class="version-menu__item"
            [class.version-menu__item--viewed]="row.id === viewed().id"
            [attr.title]="
              row.ruleSetVersion ? 'Gerada com as regras v' + row.ruleSetVersion : null
            ">
            <span class="version-menu__mark" aria-hidden="true">
              @if (row.isCurrent) {
                <i class="pi pi-check"></i>
              }
            </span>
            <div class="version-menu__body">
              <p class="version-menu__name">
                Versão {{ row.number }}
                @if (row.tag; as tag) {
                  <span class="version-tag version-tag--{{ tag.tone }}">{{ tag.label }}</span>
                }
              </p>
              <p class="version-menu__description" [title]="row.description">
                {{ row.description }}
              </p>
              <p class="version-menu__meta">
                {{ row.createdAt | vaultDateTime }} · {{ row.requestedBy }}
              </p>
            </div>
            @if (row.id === viewed().id) {
              <span class="version-menu__viewing">em exibição</span>
            } @else {
              <span class="version-menu__actions">
                <app-button
                  [label]="'Ver'"
                  [theme]="'outline-grey'"
                  [size]="'small'"
                  [noMargin]="true"
                  [ariaLabel]="'Ver a versão ' + row.number"
                  (sendButtonClick)="view(row.id)" />
                @if (row.isReady && !row.isCurrent && canSetCurrent()) {
                  <app-button
                    [label]="'Tornar atual'"
                    [theme]="'white'"
                    [size]="'small'"
                    [noMargin]="true"
                    [ariaLabel]="'Tornar a versão ' + row.number + ' a atual'"
                    [isLoading]="settingCurrentId() === row.id"
                    [disabled]="settingCurrentId() !== null"
                    (sendButtonClick)="setCurrent(row.id)" />
                }
              </span>
            }
          </li>
        }

        @if (model().failed.length) {
          <li class="version-menu__section">Não geradas</li>
          @for (row of model().failed; track row.id) {
            <li class="version-menu__failed">
              <span class="version-menu__dot" aria-hidden="true"></span>
              <button
                type="button"
                class="version-menu__failed-name"
                [attr.aria-label]="'Ver a versão ' + row.number + ', não gerada'"
                (click)="view(row.id)">
                Versão {{ row.number }}
              </button>
              <span class="version-menu__failed-reason" [title]="row.reason">{{ row.reason }}</span>
              <span class="version-menu__failed-date">{{ row.createdAt | vaultDateTime }}</span>
            </li>
          }
        }
      </ul>

      <p class="version-menu__foot">
        Ver uma versão antiga não troca a atual. O PDF enviado ao banco é sempre o da versão atual.
      </p>
    </div>
  }
</div>
